export const homepageUrl = '/';
